import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"text-align":"center"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Wähle eine Kartenart", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_Button, {
      class: "p-mr-2",
      type: "submit",
      label: "Geburtstagskarten",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (this.nextStep('Geburtstagskarte')))
    }),
    _createVNode(_component_Button, {
      class: "p-mr-2",
      type: "submit",
      label: "Taufjubiläumskarten",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (this.nextStep('Taufjubiläumskarte')))
    })
  ]))
}